import { render, staticRenderFns } from "./PrestacaoContasView.vue?vue&type=template&id=5b9c1930&"
import script from "./PrestacaoContasView.vue?vue&type=script&lang=js&"
export * from "./PrestacaoContasView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports